// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbe5c6f8","453":"9870103d","455":"980d5bc9","977":"0a553323"}[chunkId] + ".chunk.js";
};